import gql from 'graphql-tag';

export default gql`
  mutation SingleUpload($file: Upload, $path: String, $bucket: String) {
    singleUpload(file: $file, path: $path, bucket: $bucket) {
      path
    }
  }
`;
